<script>
	import { onMount } from "svelte";
	let container;

	let screenw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
	let screenh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

	onMount(() => {
		const wipeout = document.querySelector(".wipeout");
		wipeout.style.visibility = "hidden";
		wipeout.style.transform = "translateX(0%)";
		const box = container.children[0];

		let containerX = container.clientWidth - (screenw / 10);
		let containerY = container.clientHeight - (screenh / 10);
		let boxX = box.clientWidth;
		let boxY = box.clientHeight;
		console.log(boxX + " - " + boxY +" > x - y ")
		let prcentX =  1 / (boxX / containerX);
		let prcentY =  1 / (boxY / containerY);
		console.log(prcentX + " - " + prcentY +" > %x - y ")
		if ((boxY * prcentX) > containerY){
			var endboxx =  (containerX - (boxX * prcentY)) / 2 ;
			console.log(containerX + " cx")
			console.log((boxX * prcentY) + " endx")
			console.log(endboxx)
			endboxx = endboxx + (screenw / 20) 
			console.log(endboxx)
			
			/*
			box.style.marginLeft = "5vw";
			*/
			box.style.transform =  `scale(${prcentY}) translate(${endboxx}px, 2rem)` 
		}else {
			box.style.left =  `50%` 
			box.style.transform =  `scale(${prcentX}) translate(-50%, 2rem)` 
		}
		
	});

	function wipe(navfunc) {
		const wipeout = document.querySelector(".wipeout");
		wipeout.style.visibility = "visible";
		wipeout.style.transform = "translateX(-102%)";
		setTimeout(navfunc, 800);
	}
</script>

<section>
	<div bind:this={container} class="container">
		<div class="holder">
			<iframe title="cointool" src="https://cointool.app/ido/exchange?id=236b722b27777726262021267750227127242424262b242a272b245077222a2b51277525572a202226726f2625" width="{screenw}" height="{screenh}" frameborder="0" name="cointool-ido" id="cointool-ido"></iframe>
		</div>

		<a class="goto" href="https://cointool.app/ido/exchange?id=236b722b27777726262021267750227127242424262b242a272b245077222a2b51277525572a202226726f2625"><h3>Go to website...</h3></a>
	</div>

	<div class="lht-container">
		<svg
			id="LHT"
			width="366"
			height="222"
			viewBox="0 0 366 222"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				id="lht-t"
				d="M273.24 50.3849L248.4 65.671L258.214 111.809M273.24 50.3849L289.916 56.9789M273.24 50.3849L283.141 96.2432M293.042 142.102L268.029 157.947M293.042 142.102L308.328 146.618M293.042 142.102L283.141 96.2432M268.029 157.947L283.836 162.946L308.328 146.618M268.029 157.947L258.214 111.809M308.328 146.618L299.158 101.976M289.916 56.9789L326.394 71.4033L329.173 86.8631M289.916 56.9789L293.042 72.2006M293.042 72.2006L329.173 86.8631M293.042 72.2006L298.445 98.5014M329.173 86.8631L309.371 102.844L298.445 98.5014M298.445 98.5014L299.158 101.976M299.158 101.976L283.141 96.2432M283.141 96.2432L258.214 111.809"
				stroke="#FFF2E6"
				stroke-width="2"
			/>
			<path
				id="lht-h"
				d="M160.331 50.3849L134.97 65.671L144.09 111.809M160.331 50.3849L175.27 55.4224L181.359 85.2997M160.331 50.3849L169.277 95.1141M193.856 146.618L178.223 139.843M193.856 146.618L169.364 165.031L153.209 157.947M193.856 146.618L190.316 129.247M178.223 139.843L153.209 157.947M178.223 139.843L169.277 95.1141M153.209 157.947L144.09 111.809M144.09 111.809L169.277 95.1141M181.359 85.2997L184.758 101.976M181.359 85.2997L187.95 88.1771M184.758 101.976L222.694 116.914M184.758 101.976L190.316 129.247M210.88 60.6335L225.123 65.671L243.884 157.947M210.88 60.6335L184.758 76.4408L187.95 88.1771M210.88 60.6335L219.558 101.976M229.987 151.655L205.668 167.636M229.987 151.655L243.884 157.947M229.987 151.655L222.694 116.914M205.668 167.636L219.044 173.89L243.884 157.947M205.668 167.636L199.241 132.895M199.241 132.895L222.694 116.914M199.241 132.895L190.316 129.247M222.694 116.914L219.558 101.976M219.558 101.976L187.95 88.1771"
				stroke="#FFF2E6"
				stroke-width="2"
			/>
			<path
				id="lht-l"
				d="M62.5347 45L37 60.6335L47.4223 106.666M62.5347 45L77.4734 50.3849L87.0273 97.1117M62.5347 45L72.2623 91.2057M87.0273 97.1117L72.2623 91.2057M87.0273 97.1117L92.9333 125.426M72.2623 91.2057L47.4223 106.666M72.2623 91.2057L81.6424 135.848M47.4223 106.666L56.9762 151.655M81.6424 135.848L96.1852 142.102M81.6424 135.848L56.9762 151.655M133.754 158.256L131.322 142.102L92.9333 125.426M133.754 158.256L96.1852 142.102M133.754 158.256L110.999 173.89L72.2623 157.947M92.9333 125.426L96.1852 142.102M96.1852 142.102L72.2623 157.947M56.9762 151.655L72.2623 157.947"
				stroke="#FFF2E6"
				stroke-width="2"
			/>
		</svg>
	</div>
</section>

<style>

	@keyframes lht-move{
		
	0%{
		transform: translateY(-15px)
	}
	50%{
		transform: translateY(18px)
	}
	100%{
		transform: translateY(-15px)
	}
}
	section{
			width: 100vw;
			height: 100vh;
			display: flex;
			align-items: center;
			justify-content: center;
			overflow: hidden;
	}

	.container{
		margin-top: 8vh;
		margin-right: 8vw;
		width: 80vw;
		height: 80vh;
		padding: 5vh 5vw;
		border-radius: 10px;
		background: rgba(0,0,0,0.25);
		position: relative;
	}
	.holder {
		position: absolute;
		background: #000;
		top: 0;
		left: 0;
		transform-origin: 0 0;
	}

	iframe{
		width: 100vw;
		height: 90vh;
	}

	a.goto{
		min-width: 14rem;
		position: absolute;
		left: 95%;
		top: 95%;
		transform: translate(-100%, -100%) ;
		z-index: 50;
	
		text-decoration: none;
		color: white;
		background: #000;

		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0.8rem 1.6rem;
		border-radius: 50vh;
		border: 2px solid white;
		transition: all 0.3s ease;
	}
	a.goto:hover{
		text-decoration: none;
		color: #FF7A22;
		background: white;
	}
	a.goto h3{
		font-size: 1rem;
		margin: 0;
		white-space: nowrap;
	}

	.lht-container{
		position: absolute;
		bottom: 0rem;
		right: 1rem;
		z-index: 70;
		padding: 1rem;
		border-radius: 10px;
	
	}
	svg#LHT{
		z-index: -5;
		height: 6rem;
		width: auto;
	}

	svg#LHT #lht-t{
		animation-name: lht-move;
		animation-duration: 4.5s;
		animation-iteration-count: infinite;
	}
	svg#LHT #lht-l{
		animation-name: lht-move;
		animation-duration: 4s;
		animation-iteration-count: infinite;
	}
	svg#LHT #lht-h{
		animation-name: lht-move;
		animation-duration: 4.2s;
		animation-iteration-count: infinite;
	}

	@media only screen and (max-width: 800px){
		section{
			padding-top: 10vh;
		}
		.container{
			width: 98vw;
			height: 80vh;
		}
	}
</style>
